// @cspell: disable
export const onlineCourseTranslations = {
  'en-GB': {
    onlineCourse: {
      meta: {
        title: 'Colozoo – {{courseName}} Course',
        description: 'Learn {{courseName}} with Michelle Gibbs. Professional painting tutorials with subtitles in multiple languages. Enroll now on Colozoo!',
      },
      brandTitle: 'Colozoo Online Courses',
      comments: {
        title: 'Comments',
        noComments: 'Be the first! Share your experience and artworks created from this course.',
        writeComment: 'Write a comment...',
        commentButton: 'Comment',
        loginRequired: 'Please log in to leave comments.',
        writeReply: 'Write a reply...',
        replyButton: 'Reply',
        attachImage: 'Attach Image',
        save: 'Save',
        cancel: 'Cancel',
        deleteComment: 'Delete this comment?',
        deleteReply: 'Delete this reply?',
        yes: 'Yes',
        no: 'No',
        time: {
          justNow: 'Just now',
          minutes: '{{count}}m ago',
          hours: '{{count}}h ago',
          days: '{{count}}d ago'
        },
        messages: {
          commentAdded: 'Comment added successfully',
          commentAddFailed: 'Failed to add comment',
          commentEmpty: 'Comment cannot be empty',
          commentUpdated: 'Comment updated successfully',
          commentUpdateFailed: 'Failed to update comment',
          commentDeleted: 'Comment deleted successfully',
          commentDeleteFailed: 'Failed to delete comment',
          commentLikeFailed: 'Failed to like comment',
          replyAdded: 'Reply added successfully',
          replyAddFailed: 'Failed to add reply',
          replyEmpty: 'Reply cannot be empty',
          replyUpdated: 'Reply updated successfully',
          replyUpdateFailed: 'Failed to update reply',
          replyDeleted: 'Reply deleted successfully',
          replyDeleteFailed: 'Failed to delete reply',
          replyLikeFailed: 'Failed to like reply',
          imageTooLarge: 'Image must be smaller than 3MB',
          invalidImageType: 'Please select a valid image file (JPEG, PNG, GIF, WebP)',
          imageUploadFailed: 'Failed to upload image',
          networkError: 'Please check your internet connection and try again'
        }
      },
      progressSaveError: 'Could not save your progress. Please check your internet connection.',
      videoLoadError: 'Could not load video. Please check your internet connection.',
      by: 'by',
      title: '{{courseName}} Course',
      courseChapters: 'Course Chapters',
      courseProgress: 'Course Progress',
      chaptersCompleted: '{{count}} of {{total}} chapters completed',
      congratulations: 'Congratulations!',
      courseCompleted: 'You have successfully completed the course!',
      leaveReview: 'Please take a moment to leave us a review. Your feedback helps us improve!',
      leaveReviewButton: 'Leave a Review on Amazon',
      greatProgress: 'Great Progress!',
      happyWatching: 'We love your enthusiasm!',
      watchingProgressReview: 'Your feedback helps us improve. If you are enjoying the course, please leave a review.',
      duration: 'Duration: {{duration}}',
      complete: 'Complete',
      incomplete: 'Incomplete',
      noSubtitles: 'No subtitles',
      previousChapter: '← Previous Chapter',
      nextChapter: 'Next Chapter →',
      footer_2: 'Legal Notice',
      footer_3: 'Privacy Policy',
      buyOnline: 'Our Amazon Stores',
      contactUs: 'Contact',
      legal: 'Legal',
      courseAccess: {
        title: 'To continue to {{courseTitle}}, please add an Order ID',
        subtitle: 'Enter your Amazon Order ID to unlock access to this course',
        subtitleGuest: 'As a guest user, please verify your purchase with an Amazon Order ID to unlock access to this course',
        orderIdLabel: 'Amazon Order ID',
        orderIdRequired: 'Please enter your Order ID',
        orderIdInvalid: 'Please enter a valid Order ID format: 123-4567890-1234567',
        orderIdFormat: 'Format: 123-4567890-1234567',
        grantAccessButton: 'Grant Access to Course',
        howToFindTitle: 'How to find your Order ID:',
        howToFindInstructions: '1. Go to your Amazon account<br/>2. Click on "Your Orders"<br/>3. Find your Colozoo course purchase<br/>4. The Order ID is usually in the format: 123-4567890-1234567'
      },
    },
  },
  'en-US': {
    onlineCourse: {
      meta: {
        title: 'Colozoo – {{courseName}} Course',
        description: 'Learn {{courseName}} with Michelle Gibbs. Professional painting tutorials with subtitles in multiple languages. Enroll now on Colozoo!',
      },
      brandTitle: 'Colozoo Online Courses',
      comments: {
        title: 'Comments',
        noComments: 'Be the first! Share your experience and artworks created from this course.',
        writeComment: 'Write a comment...',
        commentButton: 'Comment',
        loginRequired: 'Please log in to leave comments.',
        writeReply: 'Write a reply...',
        replyButton: 'Reply',
        save: 'Save',
        cancel: 'Cancel',
        deleteComment: 'Delete this comment?',
        deleteReply: 'Delete this reply?',
        yes: 'Yes',
        no: 'No',
        time: {
          justNow: 'Just now',
          minutes: '{{count}}m ago',
          hours: '{{count}}h ago',
          days: '{{count}}d ago'
        },
        messages: {
          commentAdded: 'Comment added successfully',
          commentAddFailed: 'Failed to add comment',
          commentEmpty: 'Comment cannot be empty',
          commentUpdated: 'Comment updated successfully',
          commentUpdateFailed: 'Failed to update comment',
          commentDeleted: 'Comment deleted successfully',
          commentDeleteFailed: 'Failed to delete comment',
          commentLikeFailed: 'Failed to like comment',
          replyAdded: 'Reply added successfully',
          replyAddFailed: 'Failed to add reply',
          replyEmpty: 'Reply cannot be empty',
          replyUpdated: 'Reply updated successfully',
          replyUpdateFailed: 'Failed to update reply',
          replyDeleted: 'Reply deleted successfully',
          replyDeleteFailed: 'Failed to delete reply',
          replyLikeFailed: 'Failed to like reply',
          networkError: 'Please check your internet connection and try again'
        }
      },
      progressSaveError: 'Could not save your progress. Please check your internet connection.',
      videoLoadError: 'Could not load video. Please check your internet connection.',
      by: 'by',
      title: '{{courseName}} Course',
      courseProgress: 'Course Progress',
      chaptersCompleted: '{{count}} of {{total}} chapters completed',
      congratulations: 'Congratulations!',
      courseCompleted: 'You have successfully completed the course!',
      leaveReview: 'Please take a moment to leave us a review. Your feedback helps us improve!',
      leaveReviewButton: 'Leave a Review on Amazon',
      greatProgress: 'Great Progress!',
      happyWatching: 'We love your enthusiasm!',
      watchingProgressReview: 'Your feedback helps us improve. If you are enjoying the course, please leave a review.',
      duration: 'Duration: {{duration}}',
      complete: 'Complete',
      incomplete: 'Incomplete',
      previousChapter: '← Previous Chapter',
      nextChapter: 'Next Chapter →',
      footer_2: 'Legal Notice',
      footer_3: 'Privacy Policy',
      noSubtitles: 'No subtitles available',
      buyOnline: 'Our Amazon Stores',
      contactUs: 'Contact',
      legal: 'Legal',
      courseAccess: {
        title: 'To continue to {{courseTitle}}, please add an Order ID',
        subtitle: 'Enter your Amazon Order ID to unlock access to this course',
        subtitleGuest: 'As a guest user, please verify your purchase with an Amazon Order ID to unlock access to this course',
        orderIdLabel: 'Amazon Order ID',
        orderIdRequired: 'Please enter your Order ID',
        orderIdInvalid: 'Please enter a valid Order ID format: 123-4567890-1234567',
        orderIdFormat: 'Format: 123-4567890-1234567',
        grantAccessButton: 'Grant Access to Course',
        howToFindTitle: 'How to find your Order ID:',
        howToFindInstructions: '1. Go to your Amazon account<br/>2. Click on "Your Orders"<br/>3. Find your Colozoo course purchase<br/>4. The Order ID is usually in the format: 123-4567890-1234567'
      },
    },
  },
  de: {
    onlineCourse: {
      meta: {
        title: 'Colozoo – {{courseName}} Kurs',
        description: 'Lerne {{courseName}} mit Michelle Gibbs. Professionelle Malmalkurse mit Untertiteln in mehreren Sprachen. Jetzt anmelden auf Colozoo!',
      },
      brandTitle: 'Colozoo Online-Kurse',
      comments: {
        title: 'Kommentare',
        noComments: 'Sei der Erste! Teile deine Erfahrung und Kunstwerke aus diesem Kurs.',
        writeComment: 'Schreibe einen Kommentar...',
        commentButton: 'Kommentieren',
        loginRequired: 'Bitte melde dich an, um Kommentare zu hinterlassen.',
        writeReply: 'Schreibe eine Antwort...',
        replyButton: 'Antworten',
        save: 'Speichern',
        cancel: 'Abbrechen',
        deleteComment: 'Diesen Kommentar löschen?',
        deleteReply: 'Diese Antwort löschen?',
        yes: 'Ja',
        no: 'Nein',
        time: {
          justNow: 'Gerade eben',
          minutes: 'vor {{count}} Min.',
          hours: 'vor {{count}} Std.',
          days: 'vor {{count}} Tagen'
        },
        messages: {
          commentAdded: 'Kommentar erfolgreich hinzugefügt',
          commentAddFailed: 'Kommentar konnte nicht hinzugefügt werden',
          commentEmpty: 'Kommentar darf nicht leer sein',
          commentUpdated: 'Kommentar erfolgreich aktualisiert',
          commentUpdateFailed: 'Kommentar konnte nicht aktualisiert werden',
          commentDeleted: 'Kommentar erfolgreich gelöscht',
          commentDeleteFailed: 'Kommentar konnte nicht gelöscht werden',
          commentLikeFailed: 'Kommentar konnte nicht geliked werden',
          replyAdded: 'Antwort erfolgreich hinzugefügt',
          replyAddFailed: 'Antwort konnte nicht hinzugefügt werden',
          replyEmpty: 'Antwort darf nicht leer sein',
          replyUpdated: 'Antwort erfolgreich aktualisiert',
          replyUpdateFailed: 'Antwort konnte nicht aktualisiert werden',
          replyDeleted: 'Antwort erfolgreich gelöscht',
          replyDeleteFailed: 'Antwort konnte nicht gelöscht werden',
          replyLikeFailed: 'Antwort konnte nicht geliked werden',
          networkError: 'Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut'
        }
      },
      progressSaveError: 'Ihr Fortschritt konnte nicht gespeichert werden. Bitte überprüfen Sie Ihre Internetverbindung.',
      videoLoadError: 'Video konnte nicht geladen werden. Bitte überprüfen Sie Ihre Internetverbindung.',
      by: 'von',
      title: '{{courseName}} Kurs',
      courseChapters: 'Kurskapitel',
      courseProgress: 'Kursfortschritt',
      chaptersCompleted: '{{count}} von {{total}} Kapiteln abgeschlossen',
      congratulations: 'Herzlichen Glückwunsch!',
      courseCompleted: 'Sie haben den Kurs erfolgreich abgeschlossen!',
      leaveReview: 'Bitte nehmen Sie sich einen Moment Zeit, um uns eine Bewertung zu hinterlassen. Ihr Feedback hilft uns, uns zu verbessern!',
      leaveReviewButton: 'Bewertung auf Amazon hinterlassen',
      greatProgress: 'Großartig!',
      happyWatching: 'Wir lieben deine Begeisterung!',
      watchingProgressReview: 'Dein Feedback hilft uns zu verbessern. Wenn dir der Kurs gefällt, hinterlasse bitte eine Bewertung.',
      duration: 'Dauer: {{duration}}',
      complete: 'Abgeschlossen',
      incomplete: 'Nicht abgeschlossen',
      previousChapter: '← Vorheriges Kapitel',
      nextChapter: 'Nächstes Kapitel →',
      footer_2: 'Impressum',
      footer_3: 'Datenschutz',
      noSubtitles: 'Keine Untertitel verfügbar',
      buyOnline: 'Unsere Amazon Stores',
      contactUs: 'Kontakt',
      legal: 'Rechtliches',
      courseAccess: {
        title: 'Um mit {{courseTitle}} fortzufahren, bitte fügen Sie eine Bestell-ID hinzu',
        subtitle: 'Geben Sie Ihre Amazon-Bestell-ID ein, um den Zugang zu diesem Kurs freizuschalten',
        subtitleGuest: 'Als Gastbenutzer überprüfen Sie bitte Ihren Kauf mit einer Amazon-Bestell-ID, um den Zugang zu diesem Kurs freizuschalten',
        orderIdLabel: 'Amazon-Bestell-ID',
        orderIdRequired: 'Bitte geben Sie Ihre Bestell-ID ein',
        orderIdInvalid: 'Bitte geben Sie ein gültiges Bestell-ID-Format ein: 123-4567890-1234567',
        orderIdFormat: 'Format: 123-4567890-1234567',
        grantAccessButton: 'Zugang zum Kurs gewähren',
        howToFindTitle: 'So finden Sie Ihre Bestell-ID:',
        howToFindInstructions: '1. Gehen Sie zu Ihrem Amazon-Konto<br/>2. Klicken Sie auf "Ihre Bestellungen"<br/>3. Suchen Sie Ihren Colozoo-Kurskauf<br/>4. Die Bestell-ID hat normalerweise das Format: 123-4567890-1234567'
      },
    },
  },
  fr: {
    onlineCourse: {
      meta: {
        title: 'Colozoo – Cours {{courseName}}',
        description: 'Apprenez {{courseName}} avec Michelle Gibbs. Tutoriels de peinture professionnels avec sous-titres en plusieurs langues. Inscrivez-vous maintenant sur Colozoo!',
      },
      brandTitle: 'Colozoo Cours en Ligne',
      comments: {
        title: 'Commentaires',
        noComments: 'Soyez le premier! Partagez votre expérience et vos créations du cours.',
        writeComment: 'Écrivez un commentaire...',
        commentButton: 'Commenter',
        loginRequired: 'Veuillez vous connecter pour laisser des commentaires.',
        writeReply: 'Écrivez une réponse...',
        replyButton: 'Répondre',
        save: 'Enregistrer',
        cancel: 'Annuler',
        deleteComment: 'Supprimer ce commentaire ?',
        deleteReply: 'Supprimer cette réponse ?',
        yes: 'Oui',
        no: 'Non',
        time: {
          justNow: 'À l\'instant',
          minutes: 'il y a {{count}} min',
          hours: 'il y a {{count}} h',
          days: 'il y a {{count}} j'
        },
        messages: {
          commentAdded: 'Commentaire ajouté avec succès',
          commentAddFailed: 'Échec de l\'ajout du commentaire',
          commentEmpty: 'Le commentaire ne peut pas être vide',
          commentUpdated: 'Commentaire mis à jour avec succès',
          commentUpdateFailed: 'Échec de la mise à jour du commentaire',
          commentDeleted: 'Commentaire supprimé avec succès',
          commentDeleteFailed: 'Échec de la suppression du commentaire',
          commentLikeFailed: 'Échec du like du commentaire',
          replyAdded: 'Réponse ajoutée avec succès',
          replyAddFailed: 'Échec de l\'ajout de la réponse',
          replyEmpty: 'La réponse ne peut pas être vide',
          replyUpdated: 'Réponse mise à jour avec succès',
          replyUpdateFailed: 'Échec de la mise à jour de la réponse',
          replyDeleted: 'Réponse supprimée avec succès',
          replyDeleteFailed: 'Échec de la suppression de la réponse',
          replyLikeFailed: 'Échec du like de la réponse',
          networkError: 'Veuillez vérifier votre connexion Internet et réessayer'
        }
      },
      progressSaveError: 'Votre progression n\'a pas pu être sauvegardée. Veuillez vérifier votre connexion Internet.',
      videoLoadError: 'La vidéo n\'a pas pu être chargée. Veuillez vérifier votre connexion Internet.',
      by: 'par',
      title: 'Cours {{courseName}}',
      courseChapters: 'Chapitres du Cours',
      courseProgress: 'Progression du Cours',
      chaptersCompleted: '{{count}} sur {{total}} chapitres terminés',
      congratulations: 'Félicitations!',
      courseCompleted: 'Vous avez terminé le cours avec succès!',
      leaveReview: 'Veuillez prendre un moment pour nous laisser un avis. Vos commentaires nous aident à nous améliorer!',
      leaveReviewButton: 'Laisser un avis sur Amazon',
      greatProgress: 'Superbe!',
      happyWatching: 'Nous adorons votre enthousiasme!',
      watchingProgressReview: 'Vos commentaires nous aident à nous améliorer. Si vous aimez le cours, veuillez nous laisser un avis.',
      duration: 'Durée: {{duration}}',
      complete: 'Terminé',
      incomplete: 'Non terminé',
      previousChapter: '← Chapitre Précédent',
      nextChapter: 'Chapitre Suivant →',
      footer_2: 'Mentions Légales',
      footer_3: 'Politique de Confidentialité',
      noSubtitles: 'Aucun sous-titre disponible',
      buyOnline: 'Nos Magasins Amazon',
      contactUs: 'Contact',
      legal: 'Juridique',
      courseAccess: {
        title: 'Pour continuer vers {{courseTitle}}, veuillez ajouter un ID de commande',
        subtitle: 'Entrez votre ID de commande Amazon pour débloquer l\'accès à ce cours',
        subtitleGuest: 'En tant qu\'utilisateur invité, veuillez vérifier votre achat avec un ID de commande Amazon pour débloquer l\'accès à ce cours',
        orderIdLabel: 'ID de commande Amazon',
        orderIdRequired: 'Veuillez saisir votre ID de commande',
        orderIdInvalid: 'Veuillez saisir un format d\'ID de commande valide: 123-4567890-1234567',
        orderIdFormat: 'Format: 123-4567890-1234567',
        grantAccessButton: 'Accorder l\'accès au cours',
        howToFindTitle: 'Comment trouver votre ID de commande:',
        howToFindInstructions: '1. Allez sur votre compte Amazon<br/>2. Cliquez sur "Vos commandes"<br/>3. Trouvez votre achat de cours Colozoo<br/>4. L\'ID de commande est généralement au format: 123-4567890-1234567'
      },
    },
  },
  it: {
    onlineCourse: {
      meta: {
        title: 'Colozoo – Corso {{courseName}}',
        description: 'Impara {{courseName}} con Michelle Gibbs. Tutorial di pittura professionale con sottotitoli in più lingue. Iscriviti ora su Colozoo!',
      },
      brandTitle: 'Colozoo Corsi Online',
      comments: {
        title: 'Commenti',
        noComments: 'Sii il primo! Condividi la tua esperienza e le tue opere create da questo corso.',
        writeComment: 'Scrivi un commento...',
        commentButton: 'Commenta',
        loginRequired: 'Effettua l\'accesso per lasciare commenti.',
        writeReply: 'Scrivi una risposta...',
        replyButton: 'Rispondi',
        save: 'Salva',
        cancel: 'Annulla',
        deleteComment: 'Eliminare questo commento?',
        deleteReply: 'Eliminare questa risposta?',
        yes: 'Sì',
        no: 'No',
        time: {
          justNow: 'Proprio ora',
          minutes: '{{count}} min fa',
          hours: '{{count}} h fa',
          days: '{{count}} g fa'
        },
        messages: {
          commentAdded: 'Commento aggiunto con successo',
          commentAddFailed: 'Impossibile aggiungere il commento',
          commentEmpty: 'Il commento non può essere vuoto',
          commentUpdated: 'Commento aggiornato con successo',
          commentUpdateFailed: 'Impossibile aggiornare il commento',
          commentDeleted: 'Commento eliminato con successo',
          commentDeleteFailed: 'Impossibile eliminare il commento',
          commentLikeFailed: 'Impossibile mettere like al commento',
          replyAdded: 'Risposta aggiunta con successo',
          replyAddFailed: 'Impossibile aggiungere la risposta',
          replyEmpty: 'La risposta non può essere vuota',
          replyUpdated: 'Risposta aggiornata con successo',
          replyUpdateFailed: 'Impossibile aggiornare la risposta',
          replyDeleted: 'Risposta eliminata con successo',
          replyDeleteFailed: 'Impossibile eliminare la risposta',
          replyLikeFailed: 'Impossibile mettere like alla risposta',
          networkError: 'Verificare la connessione Internet e riprovare'
        }
      },
      progressSaveError: 'Impossibile salvare la progression. Verificare la connessione Internet.',
      videoLoadError: 'Impossibile caricare il video. Verificare la connessione Internet.',
      by: 'di',
      title: 'Corso {{courseName}}',
      courseChapters: 'Capitoli del Corso',
      courseProgress: 'Progresso del Corso',
      chaptersCompleted: '{{count}} di {{total}} capitoli completati',
      congratulations: 'Congratulazioni!',
      courseCompleted: 'Hai completato con successo il corso!',
      leaveReview: 'Prenditi un momento per lasciarci una recensione. Il tuo feedback ci aiuta a migliorare!',
      leaveReviewButton: 'Lascia una recensione su Amazon',
      greatProgress: 'Fantastico!',
      happyWatching: 'Amiamo il tuo entusiasmo!',
      watchingProgressReview: 'Il tuo feedback ci aiuta a migliorare. Se ti sta piacendo il corso, per favore lascia una recensione.',
      duration: 'Durata: {{duration}}',
      complete: 'Completato',
      incomplete: 'Non completato',
      previousChapter: '← Capitolo Precedente',
      nextChapter: 'Capitolo Successivo →',
      footer_2: 'Note Legali',
      footer_3: 'Informativa sulla Privacy',
      noSubtitles: 'Nessun sottotitolo disponibile',
      buyOnline: 'I Nostri Store Amazon',
      contactUs: 'Contatti',
      legal: 'Informazioni Legali',
      courseAccess: {
        title: 'Per continuare con {{courseTitle}}, aggiungi un ID ordine',
        subtitle: 'Inserisci il tuo ID ordine Amazon per sbloccare l\'accesso a questo corso',
        subtitleGuest: 'Come utente ospite, verifica il tuo acquisto con un ID ordine Amazon per sbloccare l\'accesso a questo corso',
        orderIdLabel: 'ID ordine Amazon',
        orderIdRequired: 'Inserisci il tuo ID ordine',
        orderIdInvalid: 'Inserisci un formato ID ordine valido: 123-4567890-1234567',
        orderIdFormat: 'Formato: 123-4567890-1234567',
        grantAccessButton: 'Concedi accesso al corso',
        howToFindTitle: 'Come trovare il tuo ID ordine:',
        howToFindInstructions: '1. Vai al tuo account Amazon<br/>2. Clicca su "I tuoi ordini"<br/>3. Trova il tuo acquisto del corso Colozoo<br/>4. L\'ID ordine è generalmente nel formato: 123-4567890-1234567'
      },
    },
  },
  es: {
    onlineCourse: {
      meta: {
        title: 'Colozoo – Curso {{courseName}}',
        description: 'Aprende {{courseName}} con Michelle Gibbs. Tutoriales de pintura profesionales con subtítulos en varios idiomas. ¡Inscríbete ahora en Colozoo!',
      },
      brandTitle: 'Colozoo Cursos en Línea',
      comments: {
        title: 'Comentarios',
        noComments: '¡Sé el primero! Comparte tu experiencia y obras creadas en este curso.',
        writeComment: 'Escribe un comentario...',
        commentButton: 'Comentar',
        loginRequired: 'Por favor inicia sesión para dejar comentarios.',
        writeReply: 'Escribe una respuesta...',
        replyButton: 'Responder',
        save: 'Guardar',
        cancel: 'Cancelar',
        deleteComment: '¿Eliminar este comentario?',
        deleteReply: '¿Eliminar esta respuesta?',
        yes: 'Sí',
        no: 'No',
        time: {
          justNow: 'Ahora mismo',
          minutes: 'hace {{count}} min',
          hours: 'hace {{count}} h',
          days: 'hace {{count}} d'
        },
        messages: {
          commentAdded: 'Comentario agregado exitosamente',
          commentAddFailed: 'Error al agregar comentario',
          commentEmpty: 'El comentario no puede estar vacío',
          commentUpdated: 'Comentario actualizado exitosamente',
          commentUpdateFailed: 'Error al actualizar comentario',
          commentDeleted: 'Comentario eliminado exitosamente',
          commentDeleteFailed: 'Error al eliminar comentario',
          commentLikeFailed: 'Error al dar like al comentario',
          replyAdded: 'Respuesta agregada exitosamente',
          replyAddFailed: 'Error al agregar respuesta',
          replyEmpty: 'La respuesta no puede estar vacía',
          replyUpdated: 'Respuesta actualizada exitosamente',
          replyUpdateFailed: 'Error al actualizar respuesta',
          replyDeleted: 'Respuesta eliminada exitosamente',
          replyDeleteFailed: 'Error al eliminar respuesta',
          replyLikeFailed: 'Error al dar like a la respuesta',
          networkError: 'Por favor, verifica tu conexión a Internet e intenta de nuevo'
        }
      },
      progressSaveError: 'No se pudo guardar tu progreso. Por favor, verifica tu conexión a Internet.',
      videoLoadError: 'No se pudo cargar el video. Por favor, verifica tu conexión a Internet.',
      by: 'de',
      title: 'Curso {{courseName}}',
      courseChapters: 'Capítulos del Curso',
      courseProgress: 'Progreso del Curso',
      chaptersCompleted: '{{count}} de {{total}} capítulos completados',
      congratulations: '¡Felicitaciones!',
      courseCompleted: '¡Has completado exitosamente el curso!',
      leaveReview: 'Por favor, tómate un momento para dejarnos una reseña. ¡Tu retroalimentación nos ayuda a mejorar!',
      leaveReviewButton: 'Dejar una reseña en Amazon',
      greatProgress: '¡Increíble!',
      happyWatching: '¡Nos encanta tu entusiasmo!',
      watchingProgressReview: 'Tu retroalimentación nos ayuda a mejorar. Si te está gustando el curso, por favor déjanos una reseña.',
      duration: 'Duración: {{duration}}',
      complete: 'Completado',
      incomplete: 'Incompleto',
      previousChapter: '← Capítulo Anterior',
      nextChapter: 'Capítulo Siguiente →',
      footer_2: 'Aviso Legal',
      footer_3: 'Política de Privacidad',
      noSubtitles: 'No hay subtítulos disponibles',
      buyOnline: 'Nuestras Tiendas de Amazon',
      contactUs: 'Contacto',
      legal: 'Legal',
      courseAccess: {
        title: 'Para continuar con {{courseTitle}}, agregue un ID de pedido',
        subtitle: 'Ingrese su ID de pedido de Amazon para desbloquear el acceso a este curso',
        subtitleGuest: 'Como usuario invitado, verifique su compra con un ID de pedido de Amazon para desbloquear el acceso a este curso',
        orderIdLabel: 'ID de pedido de Amazon',
        orderIdRequired: 'Ingrese su ID de pedido',
        orderIdInvalid: 'Ingrese un formato de ID de pedido válido: 123-4567890-1234567',
        orderIdFormat: 'Formato: 123-4567890-1234567',
        grantAccessButton: 'Conceder acceso al curso',
        howToFindTitle: 'Cómo encontrar su ID de pedido:',
        howToFindInstructions: '1. Vaya a su cuenta de Amazon<br/>2. Haga clic en "Sus pedidos"<br/>3. Encuentre su compra del curso Colozoo<br/>4. El ID de pedido generalmente tiene el formato: 123-4567890-1234567'
      },
    },
  },
}